import { type FC } from "react";

import { Switch } from "@snapchat/snap-design-system";

import { GameLensCriteriaModal } from "../../../lens/components/shared";
import { ButtonLink, LabelWithTooltip, NewTag } from "../../../shared/components";
import { useToggleState } from "../../../shared/hooks";
// The submission flow's own Game Lens copy, so the two flows can never say different things.
import {
    GameLensCriteriaLinkText,
    GameLensDescription,
    GameLensLabel,
    GameLensReviewDescription,
    GameLensTooltip,
} from "../../../submit/components/lens-details/shared/messages.generated";
import styles from "../WebLensPage.module.css";

interface WebLensGameLensToggleProps {
    isGameUserProvided: boolean;
    onGameLensToggle: (isGameUserProvided: boolean) => void;
}

/**
 * Compact presentation of the submission flow's GameLensTogglePanel for the narrow web-lens
 * details column, preserving the same product description and criteria modal.
 */
export const WebLensGameLensToggle: FC<WebLensGameLensToggleProps> = ({ isGameUserProvided, onGameLensToggle }) => {
    const [criteriaModalProps, showCriteriaModal] = useToggleState();

    return (
        <div data-testid="game-lens-toggle-panel">
            <div className={styles.gameToggleRow}>
                <div className={styles.gameToggleLead}>
                    <LabelWithTooltip
                        dataTestId="game-lens-toggle-label-with-tooltip"
                        label={
                            <span className={styles.sectionLabel}>
                                <GameLensLabel />
                            </span>
                        }
                        content={<GameLensTooltip />}
                    />
                    <NewTag />
                </div>
                <Switch
                    id="toggle-game-lens"
                    data-testid="game-lens-toggle"
                    isChecked={isGameUserProvided}
                    onChange={onGameLensToggle}
                />
            </div>
            <p className={styles.gameToggleHint}>
                <GameLensDescription />
            </p>
            <p className={styles.gameToggleHint}>
                <GameLensReviewDescription
                    criteriaLink={
                        <ButtonLink fontSize={12} onClick={showCriteriaModal}>
                            <GameLensCriteriaLinkText />
                        </ButtonLink>
                    }
                />
            </p>
            <GameLensCriteriaModal modalProps={criteriaModalProps} />
        </div>
    );
};
